import React from 'react';

import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { StyledButton, StyledTypography } from './index.styles';
import TemplatesTable from './Tables/TemplatesTable';

const TemplateManager: React.FC = () => {
    const { t } = useTranslation('templates');
    const { search } = useLocation();
    const history = useHistory();

    const handleCreateNewTemplate = () => {
        history.push(`/template-manager/create${search}`);
    };

    return (
        <>
            <StyledTypography variant="h5">{t('course-templates')}</StyledTypography>
            <Box>
                <StyledButton onClick={handleCreateNewTemplate} variant="contained">
                    {t('create-new-template')}
                </StyledButton>
            </Box>
            <TemplatesTable />
        </>
    );
};

export default TemplateManager;
